import React, { SVGProps, useId } from "react";

export const DoctorIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();
  const b = useId();
  const c = useId();
  const d = useId();
  const e = useId();
  const f = useId();
  const g = useId();
  const h = useId();
  const i = useId();
  const j = useId();
  const k = useId();
  const l = useId();
  const m = useId();
  const n = useId();
  const o = useId();
  const p = useId();
  const q = useId();
  const r = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 128 128"
      {...props}
    >
      <radialGradient
        id={a}
        cx={64.139}
        cy={4.464}
        r={69.458}
        gradientTransform="matrix(-1.08 .0045 .0029 .5843 133.401 120.64)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.559} stopColor="#f5f5f5" />
        <stop offset={1} stopColor="#c6c6c6" />
      </radialGradient>
      <path
        fill={`url(#${a})`}
        d="M64.03 95.93c-25.51.07-51.97 7.33-51.97 25.06v3.04H116v-3.04c0-17.74-26.46-25-51.97-25.06z"
      />
      <path
        fill="#543930"
        d="M98.9 79.85c-1.25-2.27.34-4.58 3.06-7.44 4.31-4.54 9-15.07 4.64-25.76.03-.06-.86-1.86-.83-1.92l-1.79-.09c-.57-.08-20.26-.12-39.97-.12s-39.4.04-39.97.12c0 0-2.65 1.95-2.63 2.01-4.35 10.69.33 21.21 4.64 25.76 2.71 2.86 4.3 5.17 3.06 7.44-1.21 2.21-4.81 2.53-4.81 2.53s.83 2.26 2.83 3.48c1.85 1.13 4.13 1.39 5.7 1.43 0 0 6.15 8.51 22.23 8.51h17.9c16.08 0 22.23-8.51 22.23-8.51 1.57-.04 3.85-.3 5.7-1.43 2-1.22 2.83-3.48 2.83-3.48s-3.61-.32-4.82-2.53z"
      />
      <radialGradient
        id={b}
        cx={99.638}
        cy={45.85}
        r={23.419}
        gradientTransform="matrix(1 0 0 .4912 -21.055 59.629)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.728} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${b})`}
        d="M63.99 95.79v-9.44l28.57-2.26 2.6 3.2s-6.15 8.51-22.23 8.51l-8.94-.01z"
      />
      <radialGradient
        id={c}
        cx={76.573}
        cy={49.332}
        r={6.921}
        gradientTransform="matrix(-.9057 .4238 -.3144 -.6719 186.513 79.36)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.663} stopColor="#6d4c41" />
        <stop offset={1} stopColor="#6d4c41" stopOpacity={0} />
      </radialGradient>
      <path
        fill={`url(#${c})`}
        d="M95.1 83.16c-4.28-6.5 5.21-8.93 5.21-8.93l.01.01c-1.65 2.05-2.4 3.84-1.43 5.61 1.21 2.21 4.81 2.53 4.81 2.53s-4.91 4.36-8.6.78z"
      />
      <radialGradient
        id={d}
        cx={94.509}
        cy={68.91}
        r={30.399}
        gradientTransform="matrix(-.0746 -.9972 .8311 -.0622 33.494 157.622)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.725} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${d})`}
        d="M106.62 46.65c4.25 10.35-.22 21.01-4.41 25.51-.57.62-3.01 3.01-3.57 4.92 0 0-9.54-13.31-12.39-21.13-.57-1.58-1.1-3.2-1.17-4.88-.05-1.26.14-2.76.87-3.83.89-1.31 20.16-1.7 20.16-1.7 0 .01.51 1.11.51 1.11z"
      />
      <radialGradient
        id={e}
        cx={44.31}
        cy={68.91}
        r={30.399}
        gradientTransform="matrix(.0746 -.9972 -.8311 -.0622 98.274 107.563)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.725} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${e})`}
        d="M21.4 46.65c-4.24 10.35.23 21.01 4.41 25.5.58.62 3.01 3.01 3.57 4.92 0 0 9.54-13.31 12.39-21.13.58-1.58 1.1-3.2 1.17-4.88.05-1.26-.14-2.76-.87-3.83-.89-1.31-1.93-.96-3.44-.96-2.88 0-15.49-.74-16.47-.74.01.02-.76 1.12-.76 1.12z"
      />
      <radialGradient
        id={f}
        cx={49.439}
        cy={45.85}
        r={23.419}
        gradientTransform="matrix(-1 0 0 .4912 98.878 59.629)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.728} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${f})`}
        d="M64.03 95.79v-9.44l-28.57-2.26-2.6 3.2s6.15 8.51 22.23 8.51l8.94-.01z"
      />
      <radialGradient
        id={g}
        cx={26.374}
        cy={49.332}
        r={6.921}
        gradientTransform="matrix(.9057 .4238 .3144 -.6719 -13.024 100.635)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.663} stopColor="#6d4c41" />
        <stop offset={1} stopColor="#6d4c41" stopOpacity={0} />
      </radialGradient>
      <path
        fill={`url(#${g})`}
        d="M32.92 83.16c4.28-6.5-5.21-8.93-5.21-8.93l-.01.01c1.65 2.05 2.4 3.84 1.43 5.61-1.21 2.21-4.81 2.53-4.81 2.53s4.91 4.36 8.6.78z"
      />
      <path
        fill="#e59600"
        d="M54.92 90.08v20.96c0 5.26 3.7 9.53 8.26 9.53h1.65c4.56 0 8.26-4.26 8.26-9.53V90.08H54.92z"
      />
      <path fill="#81d4fa" d="m52.66 102 3.85 22H71.9l3.44-22z" />
      <linearGradient
        id={h}
        x1={26.655}
        x2={26.655}
        y1={11.255}
        y2={31.458}
        gradientTransform="rotate(180 52.079 64)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.335} stopColor="#e0e0e0" />
        <stop offset={0.668} stopColor="#d0d0d0" />
        <stop offset={0.987} stopColor="#bdbdbd" />
      </linearGradient>
      <path
        fill={`url(#${h})`}
        d="M73.12 96.17c5.92.43 8.69.94 8.69.94l3.13 7.3-5.25 4.39 2.83 6.17-5.58 8.99h-6.87l3.05-27.79z"
      />
      <linearGradient
        id={i}
        x1={12.773}
        x2={12.773}
        y1={11.255}
        y2={31.458}
        gradientTransform="matrix(1 0 0 -1 37.757 128)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.335} stopColor="#e0e0e0" />
        <stop offset={0.668} stopColor="#d0d0d0" />
        <stop offset={0.987} stopColor="#bdbdbd" />
      </linearGradient>
      <path
        fill={`url(#${i})`}
        d="M54.91 96.17c-5.92.43-8.69.94-8.69.94l-3.13 7.3 5.25 4.39-2.83 6.17 5.58 8.99h6.87l-3.05-27.79z"
      />
      <path
        fill="none"
        stroke="#03a9f4"
        strokeMiterlimit={10}
        strokeWidth={3}
        d="M32.94 104.33c1.57-.82 3.4-2.02 4.25-2.76 1.92-1.67 6.47-5.97 9.86-2.94 3.66 3.21-.1 8.27-1.55 10.37-.72 1.05-1.27 2.21-1.72 3.39"
      />
      <linearGradient
        id={j}
        x1={34.007}
        x2={24.6}
        y1={23.511}
        y2={12.679}
        gradientTransform="matrix(1 0 0 -1 0 128)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#757575" />
        <stop offset={1} />
      </linearGradient>
      <path
        fill={`url(#${j})`}
        d="M29.79 111.35c-.49.08-1.02.29-1.54-.21-.34-.33-.77-1.27-.65-2.08.12-.82 1.03-1.16 2.97-1.99 1.51-.64 2.9-1.29 4.16-2.14l-1.88-2.34s-2.17 1.22-3.35 1.68c-2.09.8-4.47 1.71-4.86 4.35-.42 2.84 1.14 4.86 2.34 5.77.98.75 1.92 1.11 2.83 1.17 1.41.09 2.35-.83 2.35-2.25s-1.39-2.12-2.37-1.96z"
      />
      <linearGradient
        id={k}
        x1={42.813}
        x2={33.406}
        y1={15.863}
        y2={5.032}
        gradientTransform="matrix(1 0 0 -1 0 128)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#757575" />
        <stop offset={1} />
      </linearGradient>
      <path
        fill={`url(#${k})`}
        d="M37.03 116.79c-.01.5-.14 1.05.43 1.49.38.29 1.37.58 2.15.35.79-.24 1-1.18 1.54-3.22.42-1.58.86-3.06 1.52-4.43l2.58 1.52s-.9 2.32-1.18 3.56c-.49 2.19-1.05 4.67-3.61 5.43-2.75.83-4.98-.44-6.05-1.49-.88-.87-1.37-1.74-1.56-2.64-.29-1.38.49-2.45 1.89-2.65s2.31 1.08 2.29 2.08z"
      />
      <path
        fill="#03a9f4"
        d="M55.1 93.75c-4.63.09-7.93 2.45-9.19 3.91l2.27 1.96c.03-.03 2.45-2.74 6.92-2.86v-3.01zM86.26 102.48c-2.43-5.47-6.19-7.55-8.21-8.3-1.85-.69-3.65-.97-4.97-1.08v3.01c1.08.1 2.49.34 3.93.88 1.58.59 4.53 2.24 6.51 6.71 2.78 6.26 3.48 7.89 3.49 7.89l2.75-1.19s-.7-1.62-3.5-7.92z"
      />
      <linearGradient
        id={l}
        x1={87.856}
        x2={93.231}
        y1={18.892}
        y2={7.517}
        gradientTransform="matrix(1 0 0 -1 0 128)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#757575" />
        <stop offset={1} />
      </linearGradient>
      <circle cx={90.2} cy={114.06} r={7} fill={`url(#${l})`} />
      <circle cx={90.2} cy={114.06} r={4} fill="#9e9e9e" />
      <path
        fill="#e59600"
        d="M91.33 50.43H36.67c-5.89 0-10.71 5.14-10.71 11.41s4.82 11.41 10.71 11.41h54.65c5.89 0 10.71-5.14 10.71-11.41s-4.81-11.41-10.7-11.41z"
      />
      <path
        fill="#ffca28"
        d="M64 11.07c-17.4 0-33.52 18.61-33.52 45.4 0 26.64 16.61 39.81 33.52 39.81S97.52 83.1 97.52 56.46c0-26.78-16.12-45.39-33.52-45.39z"
      />
      <g fill="#6d4c41">
        <path d="M54.8 49.82c-.93-1.23-3.07-3.01-7.23-3.01s-6.31 1.79-7.23 3.01c-.41.54-.31 1.17-.02 1.55.26.35 1.04.68 1.9.39s2.54-1.16 5.35-1.18c2.81.02 4.49.89 5.35 1.18.86.29 1.64-.03 1.9-.39.28-.38.39-1.01-.02-1.55zM87.67 49.82c-.93-1.23-3.07-3.01-7.23-3.01s-6.31 1.79-7.23 3.01c-.41.54-.31 1.17-.02 1.55.26.35 1.04.68 1.9.39s2.54-1.16 5.35-1.18c2.81.02 4.49.89 5.35 1.18.86.29 1.64-.03 1.9-.39.28-.38.39-1.01-.02-1.55z" />
      </g>
      <g fill="#404040">
        <ellipse cx={47.56} cy={58.81} rx={4.93} ry={5.1} />
        <ellipse cx={80.44} cy={58.81} rx={4.93} ry={5.1} />
      </g>
      <path
        fill="#795548"
        d="M72.42 76.14c-3.18 1.89-13.63 1.89-16.81 0-1.83-1.09-3.7.58-2.94 2.24.75 1.63 6.44 5.42 11.37 5.42s10.55-3.79 11.3-5.42c.75-1.66-1.09-3.33-2.92-2.24z"
      />
      <path
        fill="#e59600"
        d="M67.86 68.06c-.11-.04-.21-.07-.32-.08h-7.08c-.11.01-.22.04-.32.08-.64.26-.99.92-.69 1.63.3.71 1.71 2.69 4.55 2.69s4.25-1.99 4.55-2.69c.3-.71-.05-1.37-.69-1.63z"
      />
      <path
        fill="#543930"
        d="M104.07 25.11c-2.44-3.69-7.91-8.64-12.82-8.97-.79-4.72-5.84-8.72-10.73-10.27-13.23-4.19-21.84.51-26.46 3.03-.96.52-7.17 3.97-11.51 1.5-2.72-1.55-2.67-5.74-2.67-5.74s-8.52 3.25-5.61 12.3c-2.93.12-6.77 1.36-8.8 5.47-2.42 4.9-1.56 8.99-.86 10.95-2.52 2.14-5.69 6.69-3.52 12.6 1.64 4.45 8.17 6.5 8.17 6.5-.46 8.01 1.03 12.94 1.82 14.93.14.35.63.32.72-.04.99-3.97 4.37-17.8 4.03-20.21 0 0 11.35-2.25 22.17-10.22 2.2-1.62 4.59-3 7.13-4.01 13.59-5.41 16.43 3.82 16.43 3.82s9.42-1.81 12.26 11.27c1.07 4.9 1.79 12.75 2.4 18.24.04.39.57.47.72.11.95-2.18 2.85-6.5 3.3-10.91.16-1.55 4.34-3.6 6.14-10.26 2.41-8.88-.54-17.42-2.31-20.09z"
      />
      <radialGradient
        id={m}
        cx={82.019}
        cy={84.946}
        r={35.633}
        gradientTransform="matrix(.3076 .9515 .706 -.2282 -3.184 -15.605)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.699} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${m})`}
        d="M100.22 55.5c.16-1.55 4.34-3.6 6.14-10.26.19-.71.35-1.43.5-2.15 1.46-8.09-1.16-15.52-2.79-17.98-2.26-3.41-7.1-7.89-11.69-8.81-.4-.05-.79-.1-1.16-.12 0 0 .33 2.15-.54 3.86-1.12 2.22-3.41 2.75-3.41 2.75 11.97 11.98 11.12 22 12.95 32.71z"
      />
      <radialGradient
        id={n}
        cx={47.28}
        cy={123.8}
        r={9.343}
        gradientTransform="matrix(.8813 .4726 .5603 -1.045 -63.752 111.228)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.58} stopColor="#6d4c41" />
        <stop offset={1} stopColor="#6d4c41" stopOpacity={0} />
      </radialGradient>
      <path
        fill={`url(#${n})`}
        d="M56.95 7.39c-1.1.53-2.06 1.06-2.9 1.51-.96.52-7.17 3.97-11.51 1.5-2.67-1.52-2.67-5.58-2.67-5.72-1.23 1.57-4.95 12.78 5.93 13.53 4.69.32 7.58-3.77 9.3-7.23.62-1.26 1.59-3.1 1.85-3.59z"
      />
      <radialGradient
        id={o}
        cx={159.055}
        cy={62.862}
        r={28.721}
        gradientTransform="matrix(-.9378 -.3944 -.2182 .5285 231.04 50.678)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.699} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${o})`}
        d="M79.16 5.47c7.32 1.98 10.89 5.71 12.08 10.68.35 1.46.77 15.08-25.23-.4-9.67-5.76-7.03-9.36-5.9-9.77 4.42-1.6 10.85-2.73 19.05-.51z"
      />
      <radialGradient
        id={p}
        cx={43.529}
        cy={115.276}
        r={8.575}
        gradientTransform="matrix(1 0 0 -1.2233 0 153.742)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.702} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${p})`}
        d="M39.84 4.68c-.01.01-.03.01-.06.03h-.01c-.93.39-8.24 3.78-5.51 12.25l7.78 1.25c-6.89-6.98-2.17-13.55-2.17-13.55s-.02.01-.03.02z"
      />
      <radialGradient
        id={q}
        cx={42.349}
        cy={100.139}
        r={16.083}
        gradientTransform="matrix(-.9657 -.2598 -.2432 .9037 107.598 -51.632)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.66} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${q})`}
        d="m39.07 17.73-4.81-.77c-.19 0-.83.06-1.18.11-2.71.38-5.9 1.78-7.63 5.36-1.86 3.86-1.81 7.17-1.3 9.38.15.74.45 1.58.45 1.58s2.38-2.26 8.05-2.41l6.42-13.25z"
      />
      <radialGradient
        id={r}
        cx={38.533}
        cy={84.609}
        r={16.886}
        gradientTransform="matrix(.9907 .1363 .1915 -1.3921 -15.841 155.923)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.598} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${r})`}
        d="M24.37 33.58c-2.37 2.1-5.56 6.79-3.21 12.61 1.77 4.39 8.09 6.29 8.09 6.29 0 .02 1.26.4 1.91.4l1.48-21.9c-3.03 0-5.94.91-7.82 2.22.03.03-.46.35-.45.38z"
      />
    </svg>
  );
};
